import { Injectable, Injector } from '@angular/core';
import { BeneficiaireService } from './api/beneficiaire/beneficiaire.service';
import { MissionPlaceService } from './api/mission-place/mission-place.service';
import { FormationService } from './api/formation/formation.service';
import { EmployeeService } from './api/employee/employee.service';
import { DataStorageService } from './dataStorage/data-storage.service';
import { MessageService } from './api/message/message.service';
import { MissionService } from './api/mission/mission.service';
import { NominatimService } from './nominatim/nominatim.service';
import { PlanningService } from './api/planning/planning.service';
import { RoleService } from './api/role/role.service';
import { SolutionService } from './api/solution/solution.service';
import { SpecialiteService } from './api/specialite/specialite.service';
import { StatistiqueService } from './api/statistique/statistique.service';
import { ToastService } from './toast/toast.service';
import { VacationTypeService } from './api/vacation-type/vacation-type.service';
import { UserService } from './api/user/user.service';
import { VehiculeService } from './api/vehicule/vehicule.service';
import { AuthenticationService } from './api/authentication/authentication.service';
import { NotificationService } from './api/notification/notification.service';
import { VacationService } from './api/vacation/vacation.service';
import { UnavailabilityService } from './api/unavailability/unavailability.service';
import { CenterService } from './api/center/center.service';
import { MobileService } from './mobile/mobile.service';
import { RouteService } from './api/route/route.service';
import { AreaService } from './api/area/area.service';
import { MissionTypeService } from './api/mission-type/mission-type.service';
import { CacheService } from './cache/cache.service';
import { ExportService } from './api/export/export.service';
import { FunderService } from './api/funder/funder.service';
import { AvailabilityService } from './api/availability/availability.service';
import { MeetingService } from './api/meeting/meeting.service';
import { ParcoursService } from './api/parcours/parcours.service';
import { PrescriberService } from './api/prescriber/prescriber.service';
import { CareSkillService } from './api/care-skill/care-skill.service';
import { CenterDepartmentService } from './api/center-department/center-department.service';

@Injectable({
	providedIn: 'root'
})
export class FacadeService {
	private _beneficiaireService: BeneficiaireService;
	public get beneficiaireService(): BeneficiaireService {
		if (!this._beneficiaireService) {
			this._beneficiaireService = this.injector.get(BeneficiaireService);
		}
		return this._beneficiaireService;
	}

	private _missionPlaceService: MissionPlaceService;
	public get missionPlaceService(): MissionPlaceService {
		if (!this._missionPlaceService) {
			this._missionPlaceService = this.injector.get(MissionPlaceService);
		}
		return this._missionPlaceService;
	}

	private _formationService: FormationService;
	public get formationService(): FormationService {
		if (!this._formationService) {
			this._formationService = this.injector.get(FormationService);
		}
		return this._formationService;
	}

	private _employeeService: EmployeeService;
	public get employeeService(): EmployeeService {
		if (!this._employeeService) {
			this._employeeService = this.injector.get(EmployeeService);
		}
		return this._employeeService;
	}

	private _dataStorageService: DataStorageService;
	public get dataStorageService(): DataStorageService {
		if (!this._dataStorageService) {
			this._dataStorageService = this.injector.get(DataStorageService);
		}
		return this._dataStorageService;
	}

	private _missionService: MissionService;
	public get missionService(): MissionService {
		if (!this._missionService) {
			this._missionService = this.injector.get(MissionService);
		}
		return this._missionService;
	}

	private _nominatimService: NominatimService;
	public get nominatimService(): NominatimService {
		if (!this._nominatimService) {
			this._nominatimService = this.injector.get(NominatimService);
		}
		return this._nominatimService;
	}

	private _planningService: PlanningService;
	public get planningService(): PlanningService {
		if (!this._planningService) {
			this._planningService = this.injector.get(PlanningService);
		}
		return this._planningService;
	}

	private _roleService: RoleService;
	public get roleService(): RoleService {
		if (!this._roleService) {
			this._roleService = this.injector.get(RoleService);
		}
		return this._roleService;
	}

	private _specialiteService: SpecialiteService;
	public get specialiteService(): SpecialiteService {
		if (!this._specialiteService) {
			this._specialiteService = this.injector.get(SpecialiteService);
		}
		return this._specialiteService;
	}

	private _statistiqueService: StatistiqueService;
	public get statistiqueService(): StatistiqueService {
		if (!this._statistiqueService) {
			this._statistiqueService = this.injector.get(StatistiqueService);
		}
		return this._statistiqueService;
	}

	private _vacationTypeService: VacationTypeService;
	public get vacationTypeService(): VacationTypeService {
		if (!this._vacationTypeService) {
			this._vacationTypeService = this.injector.get(VacationTypeService);
		}
		return this._vacationTypeService;
	}

	private _userService: UserService;
	public get userService(): UserService {
		if (!this._userService) {
			this._userService = this.injector.get(UserService);
		}
		return this._userService;
	}

	private _toastService: ToastService;
	public get toastService(): ToastService {
		if (!this._toastService) {
			this._toastService = this.injector.get(ToastService);
		}
		return this._toastService;
	}

	private _vehiculeService: VehiculeService;
	public get vehiculeService(): VehiculeService {
		if (!this._vehiculeService) {
			this._vehiculeService = this.injector.get(VehiculeService);
		}
		return this._vehiculeService;
	}

	private _solutionService: SolutionService;
	public get solutionService(): SolutionService {
		if (!this._solutionService) {
			this._solutionService = this.injector.get(SolutionService);
		}
		return this._solutionService;
	}

	private _authenticationService: AuthenticationService;
	public get authenticationService(): AuthenticationService {
		if (!this._authenticationService) {
			this._authenticationService = this.injector.get(AuthenticationService);
		}
		return this._authenticationService;
	}
	private _MessageService: MessageService;
	public get messageService(): MessageService {
		if (!this._MessageService) {
			this._MessageService = this.injector.get(MessageService);
		}
		return this._MessageService;
	}

	private _NotificationService: NotificationService;
	public get notificationService(): NotificationService {
		if (!this._NotificationService) {
			this._NotificationService = this.injector.get(NotificationService);
		}
		return this._NotificationService;
	}

	private _VacationService: VacationService;
	public get vacationService(): VacationService {
		if (!this._VacationService) {
			this._VacationService = this.injector.get(VacationService);
		}
		return this._VacationService;
	}

	private _UnavailabilityService: UnavailabilityService;
	public get unavailabilityService(): UnavailabilityService {
		if (!this._UnavailabilityService) {
			this._UnavailabilityService = this.injector.get(UnavailabilityService);
		}
		return this._UnavailabilityService;
	}

	private _CenterService: CenterService;
	public get centerService(): CenterService {
		if (!this._CenterService) {
			this._CenterService = this.injector.get(CenterService);
		}
		return this._CenterService;
	}

	private _MobileService: MobileService;
	public get mobileService(): MobileService {
		if (!this._MobileService) {
			this._MobileService = this.injector.get(MobileService);
		}
		return this._MobileService;
	}

	private _RouteService: RouteService;
	public get routeService(): RouteService {
		if (!this._RouteService) {
			this._RouteService = this.injector.get(RouteService);
		}
		return this._RouteService;
	}

	private _ExportService: ExportService;
	public get exportService(): ExportService {
		if (!this._ExportService) {
			this._ExportService = this.injector.get(ExportService);
		}
		return this._ExportService;
	}

	private _AreaService: AreaService;
	public get areaService(): AreaService {
		if (!this._AreaService) {
			this._AreaService = this.injector.get(AreaService);
		}
		return this._AreaService;
	}

	private _MissionTypeService: MissionTypeService;
	public get missionTypeService(): MissionTypeService {
		if (!this._MissionTypeService) {
			this._MissionTypeService = this.injector.get(MissionTypeService);
		}
		return this._MissionTypeService;
	}

	private _CacheService: CacheService;
	public get cacheService(): CacheService {
		if (!this._CacheService) {
			this._CacheService = this.injector.get(CacheService);
		}
		return this._CacheService;
	}

	private _AvailabilityService: AvailabilityService;
	public get availabilityService(): AvailabilityService {
		if (!this._AvailabilityService) {
			this._AvailabilityService = this.injector.get(AvailabilityService);
		}
		return this._AvailabilityService;
	}

	private _FunderService: FunderService;
	public get funderService(): FunderService {
		if (!this._FunderService) {
			this._FunderService = this.injector.get(FunderService);
		}
		return this._FunderService;
	}

	private _MeetingService: MeetingService;
	public get meetingService(): MeetingService {
		if (!this._MeetingService) {
			this._MeetingService = this.injector.get(MeetingService);
		}
		return this._MeetingService;
	}

	private _ParcoursService: ParcoursService;
	public get parcoursService(): ParcoursService {
		if (!this._ParcoursService) {
			this._ParcoursService = this.injector.get(ParcoursService);
		}
		return this._ParcoursService;
	}

	private _PrescriberService: PrescriberService;
	public get prescriberService(): PrescriberService {
		if (!this._PrescriberService) {
			this._PrescriberService = this.injector.get(PrescriberService);
		}
		return this._PrescriberService;
	}

	private _CareSkillService: CareSkillService;
	public get careSkillService(): CareSkillService {
		if (!this._CareSkillService) {
			this._CareSkillService = this.injector.get(CareSkillService);
		}
		return this._CareSkillService;
	}

	private _CenterDepartmentService: CenterDepartmentService;
	public get centerDepartmentService(): CenterDepartmentService {
		if (!this._CenterDepartmentService) {
			this._CenterDepartmentService = this.injector.get(
				CenterDepartmentService
			);
		}
		return this._CenterDepartmentService;
	}

	constructor(private injector: Injector) {}
}
